import { render, staticRenderFns } from "./radio-disabled.mpx?vue&type=template&id=de65a29a&isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex"
import script from "./radio-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex"
export * from "./radio-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex"
import style0 from "./radio-disabled.mpx?vue&type=style&index=0&id=de65a29a&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_7c3342c5%22%7D&isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports